import { MedicalDeviceOrderStatus } from '@dreryk/egabinet-ezwm-frontend-api';

import { Dropdown, MoreIconVertical } from '@dreryk/react-components';

import { useGetCurrentHealthcareProviderType } from '~libs.shared.account';

import { MedicalDeviceOrderEzwmAuthenticationFault } from '../../medicalDeviceOrder/MedicalDeviceOrderEzwmLoginErrorsModal';

import { CorrectionDropdownItem } from './CorrectionDropdownItem';
import { useVerifyAgainAction } from './VerifyAgainDropdownItem.hooks';
import { VerifyAgainDropdownItem } from './VerifyAgainDropdownItem';

type OptionsCellProps = {
   readonly externalId: string;
   readonly medicalDeviceOrderId: number;
   readonly visitId: number;
   readonly medicalDeviceOrderStatus: MedicalDeviceOrderStatus;
   readonly onVerificationRetryFetchSuccess: VoidFunction;
   readonly sameAsCurrentVisit: boolean;
   readonly onFault: (fault: MedicalDeviceOrderEzwmAuthenticationFault) => void;
};

const NOT_APPLICABLE_STATUSES: MedicalDeviceOrderStatus[] = ['PAPER', 'ACCEPTED', 'COMPLETED'];

export const OptionsCell = (props: OptionsCellProps): JSX.Element | null => {
   const healthcareProviderType = useGetCurrentHealthcareProviderType();
   const { verifyAgain, renderMfaModal } = useVerifyAgainAction({
      externalId: props.externalId,
      healthcareProviderType: healthcareProviderType,
      onSuccess: props.onVerificationRetryFetchSuccess,
      onFault: props.onFault,
   });

   if (NOT_APPLICABLE_STATUSES.includes(props.medicalDeviceOrderStatus) || !healthcareProviderType) {
      return null;
   }
   return (
      <>
         <Dropdown testId={'options'} triggerIcon={<MoreIconVertical />}>
            <VerifyAgainDropdownItem
               medicalDeviceOrderStatus={props.medicalDeviceOrderStatus}
               sameAsCurrentVisit={props.sameAsCurrentVisit}
               onVerifyAgain={verifyAgain}
            />
            <CorrectionDropdownItem
               medicalDeviceOrderId={props.medicalDeviceOrderId}
               visitId={props.visitId}
               medicalDeviceOrderStatus={props.medicalDeviceOrderStatus}
               sameAsCurrentVisit={props.sameAsCurrentVisit}
            />
         </Dropdown>
         {renderMfaModal()}
      </>
   );
};
